import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <path d="M11,3 L12.111,8 L21,8 C22.1045695,8 23,8.8954305 23,10 L23,12 L24,13.0544906 L24,15.0554243 L23,15.9887092 L23,25 C23,26.1045695 22.1045695,27 21,27 L9,27 C7.8954305,27 7,26.1045695 7,25 L7,3 L11,3 Z M9.796,4.5 L8.5,4.5 L8.5,25 C8.5,25.2454599 8.67687516,25.4496084 8.91012437,25.4919443 L9,25.5 L21,25.5 C21.2454599,25.5 21.4496084,25.3231248 21.4919443,25.0898756 L21.5,25 L21.5,15.3368576 L22.5,14.403 L22.5,13.653 L21.5,12.5981468 L21.5,10 C21.5,9.75454011 21.3231248,9.55039163 21.0898756,9.50805567 L21,9.5 L10.9077165,9.5 L9.796,4.5 Z M16.9426174,12 L15,16.8393859 L18.1785451,17.925631 L13.1027909,23.9400498 L15,18.9125926 L12,18.0487785 L16.9426174,12 Z"></path>
  </React.Fragment>,
  'Vapes'
)
